import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { ApiError } from "@/api/client";
import { useMe } from "@/hooks/useAuth";

function authStatus(error: unknown): number | undefined {
  if (error instanceof ApiError) return error.status;
  return (error as { status?: number })?.status;
}

export default function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const me = useMe();

  if (me.isLoading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center text-[#003f28]/70"
        role="status"
      >
        Comprobando sesión…
      </div>
    );
  }

  if (me.isError && authStatus(me.error) === 401) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/access" state={{ from: returnTo }} replace />;
  }

  return <>{children}</>;
}
